import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../../../components/ui/dialog';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { UserPlus, ChevronRight } from 'lucide-react';

export const AddParentDialog = ({
  open,
  onOpenChange,
  selectedPlayer,
  parentSearch,
  setParentSearch,
  allParents,
  onAdd,
}) => {
  const filteredParents = parentSearch
    ? allParents.filter(
        (p) =>
          (p.name || '').toLowerCase().includes(parentSearch.toLowerCase()) ||
          (p.email || '').toLowerCase().includes(parentSearch.toLowerCase())
      )
    : allParents;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <UserPlus className="h-5 w-5 text-blue-600" />
            Add Parent to Player
          </DialogTitle>
          <DialogDescription>
            {selectedPlayer && `Add an additional parent to ${selectedPlayer.full_name}`}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div>
            <Label>Search Parent</Label>
            <Input
              placeholder="Search by name or email..."
              value={parentSearch}
              onChange={(e) => setParentSearch(e.target.value)}
              data-testid="add-parent-search"
            />
          </div>

          <div className="max-h-60 overflow-y-auto border rounded-lg">
            {filteredParents.slice(0, 20).map((parent) => (
              <div
                key={parent.id}
                className="p-3 border-b last:border-b-0 hover:bg-slate-50 cursor-pointer flex items-center justify-between"
                onClick={() => onAdd(parent.id)}
                data-testid={`add-parent-row-${parent.id}`}
              >
                <div>
                  <p className="font-medium">{parent.name}</p>
                  <p className="text-sm text-slate-500">{parent.email}</p>
                </div>
                <ChevronRight className="h-4 w-4 text-slate-400" />
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
